import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, createUrlTreeFromSnapshot } from '@angular/router';
import { QuizProgressFacade } from '../facades/quiz-progress.facade';
import { combineLatest, filter, map, take, tap } from 'rxjs';

export const quizProgressLoaded: CanActivateFn = (route: ActivatedRouteSnapshot) => {
    const progressFacade = inject(QuizProgressFacade);
    const quizId = route.paramMap.get('quizId');

    if (!quizId) {
        return createUrlTreeFromSnapshot(route, ['/dashboard']);
    }

    return combineLatest([progressFacade.quizId$, progressFacade.loaded$]).pipe(
        tap(([stateQuizId, loaded]) => {
            // Fetch if not loaded OR if loaded for a different quiz
            if (loaded !== true || stateQuizId !== quizId) {
                progressFacade.getProgress(quizId);
            }
        }),
        filter(([stateQuizId, loaded]) => stateQuizId === quizId && loaded !== null),
        map(([, loaded]) => {
            // loaded can be true even if progress is null (not started yet)
            // Only redirect on actual error (loaded === false)
            if (loaded === false) {
                return createUrlTreeFromSnapshot(route, ['/dashboard']);
            }
            return true;
        }),
        take(1),
    );
};
